// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeContainerOffice {
    width: 100%;
    color: aliceblue;
}

.Office {
    color: #e1e1e1;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;

}

.sensorIcon img {
    width: 80px !important;
    height: 80px !important;
    object-fit: contain !important;

}

.HeadingOfDanger .MuiSvgIcon-root {
    fill: #E16162 !important;
    margin-bottom: -3px;
}

.HeadingOfDanger {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%) !important;
    font-size: 18px !important;
    height: 30px !important;
}

.roomClimateHeader {
    background-color: #195faf;
    width: 93%;
    height: 40px;
}

.danger {
    height: auto;
    width: 250px;
    margin-top: 20px;
    margin: 10px;

}

textarea{
    color: white !important;
}

.assetDetailActionButtons {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    margin-top: 10px;
    gap: 2px;
}

.actionButtonDelete {

    text-align: center;

    cursor: pointer;
}

.actionButtonEdit button {
    background-color: none !important;
    margin: 0 !important;
    background: none !important;
}

.actionButtonEdit button:hover {
    
    background-color: #383c42 !important;
}

.actionButtonDelete button {
    background-color: none !important;
    margin: 0 !important;
    background: none !important;
}

.actionButtonDelete button:hover {
    background-color: #383c42 !important;
}

.assetDetailActionButtons .actionButtonEdit {
    float: right !important;
    cursor: pointer;
}
.editIconButton{
    float: right !important;
}




.homeContainerOffice .MuiGrid-root {
    display: 'flex';
    justify-content: 'center';
    align-items: 'center';
}

.updateConfButton{
    font-size: 12px !important;
    width: 100% !important;
}

.addSensorButton{
    width: 100% !important;
}

.updateAssetButton{
    width: 100% !important;
}

.danger div {
    text-align: center;
    font-size: 14px;
    color: white;
    padding: 5px;
    display: inherit;
    align-items: center;
    justify-content: center;
    background-color: #282B30;
    height: auto;
}
.alarmLabel:hover {
    animation: none;
  }
  .bigger {
    transform: scale(1.5) !important; /* Increase the size of the dot */
  }
  .alarmLabel:hover {
    animation: none !important; 
  }
    

.bodyOfDanger {
    background-color: #282B30;
    height: auto !important;
    text-align: center;
    padding: 10px !important;
}

.roomClimateBody {
    width: 93%;
    background-color: #282B30;
    height: 200px;
}



.visitorHeader {
    background-color: #19191C !important;
    font-size: 18px !important;
    height: 30px !important;
}

.visitorBody {
    background-color: #282B30;
    height: auto !important;
    padding: 10px !important;
}

.warnSign {
    background-color: #E16162;
    border-radius: 50%;
    padding: 4px;
}

.check {
    background-color: #4996EE;
    border-radius: 50%;
    padding: 3px;
}

.dangerIcon .css-i4bv87-MuiSvgIcon-root {
    color: #E16162 !important;
    font-size: 5.5rem !important;
    fill: #E16162 !important;

}

.visitor {
    font-size: 14px;
    color: white;
    padding: 5px;
    display: inherit;
    align-items: center;
    justify-content: center;
    background-color: #282B30;
    height: auto;
    margin-top: 10px;

}

.temperature {
    font-size: 14px;
}

.temperature span .css-i4bv87-MuiSvgIcon-root {
    font-size: 1.2rem !important;
}

.updatedTime {
    font-size: 12px;
}

.updatedTime span .css-i4bv87-MuiSvgIcon-root {
    font-size: 1.2rem !important;
}

.dangerAlert {
    margin-bottom: 15px;
}

.Office button {
    border-radius: 0 !important;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    margin-bottom: 15px;
}

.Office button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}
.labels{
border-radius: 0 !important;
z-index: 1000 !important;
}

.alarmLabel {
    background-color: rgb(200, 55, 55) !important;
    
  }
  .noHoverBlink {
    animation: none !important;
  }
.dangerContainer {

    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

.addNewSensorButton {
    display: flex;
  align-items: center; /* Vertical alignment */
  justify-content: center; /* Horizontal alignment */

}

.alarm.true {
    background-color: rgb(80, 31, 31);
    animation: blinker 2s linear infinite;
}

@keyframes blinker {
    50% {
        opacity: 0;
    }
}



@media (max-width: 1200px) {
    .visitor {

        margin-top: 20px;

    }
}

@media (max-width: 900px) {
    .addNewSensorButton {
        text-align: center;
    }
}

@media (min-width: 900px) and (max-width: 1115px) {
    .Office button {
        font-size: 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/AssetDetail/AssetDetail.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;AAExC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;;AAElC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,4FAA4F;IAC5F,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;;IAEI,kBAAkB;;IAElB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;;;;;AAKA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,eAAe;EACjB;EACA;IACE,gCAAgC,EAAE,iCAAiC;EACrE;EACA;IACE,0BAA0B;EAC5B;;;AAGF;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,aAAa;AACjB;;;;AAIA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;;AAE5B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,iFAAiF;IACjF,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iFAAiF;AACrF;AACA;AACA,2BAA2B;AAC3B,wBAAwB;AACxB;;AAEA;IACI,6CAA6C;;EAE/C;EACA;IACE,0BAA0B;EAC5B;AACF;;IAEI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;EACf,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;;AAEpD;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;AACzC;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;;;AAIA;IACI;;QAEI,gBAAgB;;IAEpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".homeContainerOffice {\n    width: 100%;\n    color: aliceblue;\n}\n\n.Office {\n    color: #e1e1e1;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n\n}\n\n.sensorIcon img {\n    width: 80px !important;\n    height: 80px !important;\n    object-fit: contain !important;\n\n}\n\n.HeadingOfDanger .MuiSvgIcon-root {\n    fill: #E16162 !important;\n    margin-bottom: -3px;\n}\n\n.HeadingOfDanger {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%) !important;\n    font-size: 18px !important;\n    height: 30px !important;\n}\n\n.roomClimateHeader {\n    background-color: #195faf;\n    width: 93%;\n    height: 40px;\n}\n\n.danger {\n    height: auto;\n    width: 250px;\n    margin-top: 20px;\n    margin: 10px;\n\n}\n\ntextarea{\n    color: white !important;\n}\n\n.assetDetailActionButtons {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr !important;\n    margin-top: 10px;\n    gap: 2px;\n}\n\n.actionButtonDelete {\n\n    text-align: center;\n\n    cursor: pointer;\n}\n\n.actionButtonEdit button {\n    background-color: none !important;\n    margin: 0 !important;\n    background: none !important;\n}\n\n.actionButtonEdit button:hover {\n    \n    background-color: #383c42 !important;\n}\n\n.actionButtonDelete button {\n    background-color: none !important;\n    margin: 0 !important;\n    background: none !important;\n}\n\n.actionButtonDelete button:hover {\n    background-color: #383c42 !important;\n}\n\n.assetDetailActionButtons .actionButtonEdit {\n    float: right !important;\n    cursor: pointer;\n}\n.editIconButton{\n    float: right !important;\n}\n\n\n\n\n.homeContainerOffice .MuiGrid-root {\n    display: 'flex';\n    justify-content: 'center';\n    align-items: 'center';\n}\n\n.updateConfButton{\n    font-size: 12px !important;\n    width: 100% !important;\n}\n\n.addSensorButton{\n    width: 100% !important;\n}\n\n.updateAssetButton{\n    width: 100% !important;\n}\n\n.danger div {\n    text-align: center;\n    font-size: 14px;\n    color: white;\n    padding: 5px;\n    display: inherit;\n    align-items: center;\n    justify-content: center;\n    background-color: #282B30;\n    height: auto;\n}\n.alarmLabel:hover {\n    animation: none;\n  }\n  .bigger {\n    transform: scale(1.5) !important; /* Increase the size of the dot */\n  }\n  .alarmLabel:hover {\n    animation: none !important; \n  }\n    \n\n.bodyOfDanger {\n    background-color: #282B30;\n    height: auto !important;\n    text-align: center;\n    padding: 10px !important;\n}\n\n.roomClimateBody {\n    width: 93%;\n    background-color: #282B30;\n    height: 200px;\n}\n\n\n\n.visitorHeader {\n    background-color: #19191C !important;\n    font-size: 18px !important;\n    height: 30px !important;\n}\n\n.visitorBody {\n    background-color: #282B30;\n    height: auto !important;\n    padding: 10px !important;\n}\n\n.warnSign {\n    background-color: #E16162;\n    border-radius: 50%;\n    padding: 4px;\n}\n\n.check {\n    background-color: #4996EE;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.dangerIcon .css-i4bv87-MuiSvgIcon-root {\n    color: #E16162 !important;\n    font-size: 5.5rem !important;\n    fill: #E16162 !important;\n\n}\n\n.visitor {\n    font-size: 14px;\n    color: white;\n    padding: 5px;\n    display: inherit;\n    align-items: center;\n    justify-content: center;\n    background-color: #282B30;\n    height: auto;\n    margin-top: 10px;\n\n}\n\n.temperature {\n    font-size: 14px;\n}\n\n.temperature span .css-i4bv87-MuiSvgIcon-root {\n    font-size: 1.2rem !important;\n}\n\n.updatedTime {\n    font-size: 12px;\n}\n\n.updatedTime span .css-i4bv87-MuiSvgIcon-root {\n    font-size: 1.2rem !important;\n}\n\n.dangerAlert {\n    margin-bottom: 15px;\n}\n\n.Office button {\n    border-radius: 0 !important;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    margin-bottom: 15px;\n}\n\n.Office button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n.labels{\nborder-radius: 0 !important;\nz-index: 1000 !important;\n}\n\n.alarmLabel {\n    background-color: rgb(200, 55, 55) !important;\n    \n  }\n  .noHoverBlink {\n    animation: none !important;\n  }\n.dangerContainer {\n\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n}\n\n.addNewSensorButton {\n    display: flex;\n  align-items: center; /* Vertical alignment */\n  justify-content: center; /* Horizontal alignment */\n\n}\n\n.alarm.true {\n    background-color: rgb(80, 31, 31);\n    animation: blinker 2s linear infinite;\n}\n\n@keyframes blinker {\n    50% {\n        opacity: 0;\n    }\n}\n\n\n\n@media (max-width: 1200px) {\n    .visitor {\n\n        margin-top: 20px;\n\n    }\n}\n\n@media (max-width: 900px) {\n    .addNewSensorButton {\n        text-align: center;\n    }\n}\n\n@media (min-width: 900px) and (max-width: 1115px) {\n    .Office button {\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
